
import React from "react";
import { Layout } from "@/components/layout/Layout";
import { CloseDashboard } from "@/components/close-crm/CloseDashboard";
import { CloseProvider } from "@/contexts/CloseContext";

const CloseCRM = () => {
  return (
    <CloseProvider>
      <Layout>
        <CloseDashboard />
      </Layout>
    </CloseProvider>
  );
};

export default CloseCRM;
